import * as Sentry from '@sentry/react';
import jwtDecode from 'jwt-decode';
import { type RmClaims } from 'src/api/queries/user';

export function decodeAccessToken(token: string): RmClaims {
  try {
    return jwtDecode<RmClaims>(token);
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        function: 'decodeAccessToken',
      },
    });
    throw new Error('Failed to decode access token', { cause: error });
  }
}
